import {ElMessageBox} from 'element-plus'
import axios from '../request'

export default (callback) => {
  return async id => {
    try {
      await ElMessageBox.confirm(
        '删除这条景区？',
        '请确认',
        {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning',
        }
      )
      await axios.delete(`/scenic_spots/${id}`)
      callback()
    } catch {

    }
  }
}

export const useDeleteHotel = (callback) => {
    return async id => {
        try {
            await ElMessageBox.confirm(
                '删除这个酒店？',
                '请确认',
                {
                    confirmButtonText: '确认',
                    cancelButtonText: '取消',
                    type: 'warning',
                }
            )
            await axios.delete(`/hotels/${id}`)
            callback()
        } catch {

        }
    }
}
